import React, { Component } from 'react';

import TimbradoTicketSearch from './TimbradoTicketSearch';
import TimbradoTicketRequest from './TimbradoTicketRequest';
import PageHeader from '../../../../support/page-header/PageHeader';

class TimbradoTicket extends Component {
  state = {
    data: null,
  };

  handleOnChange = (event) => {
    this.setState({ ...event });
  };

  render() {
    const { data } = this.state;

    return (
      <>
        <PageHeader
          text="Tickets"
          to="/modulos/autofacturacion/tickets"
        />

        <TimbradoTicketSearch onChange={this.handleOnChange} />

        {!!data && <TimbradoTicketRequest data={{ ...data }} />}
      </>
    );
  }
}

export default TimbradoTicket;
